import { SerializedFarmConfig } from './types'

export function serializeFarm(farm): SerializedFarmConfig {
  const token = farm.token.serialize
  const quoteToken = farm.quoteToken.serialize
  const earningToken = farm.earningToken.serialize
  const symbol = `${farm.token.symbol}-${farm.quoteToken.symbol}`
  const lpSymbol = `${symbol} LP`

  return {
    ...farm,
    token,
    quoteToken,
    earningToken,
    symbol,
    lpSymbol,
  }
}
